import { signal } from '@angular/core';
import { PredictiveSearch } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { TripTypeOptions } from '../../constants/book-widget.constants';
import { BookWidgetAem } from '../../models/book-widget-aem.interfaces';
import { InfoPopUpContent } from '../common/info-popup-modal/models/info-popup-modal.interface';

export class ModifyBookWidgetExtendedComponent {
  tripTypeOptions = TripTypeOptions;
  infoPopUpModalData = signal<InfoPopUpContent>({} as InfoPopUpContent);

  protected predictiveSearchConfig = signal<Omit<PredictiveSearch, 'items'>>({
    placeholder: '',
    title: '',
    value: '',
    transparentSearch: true,
    errorMessage: '',
    selectLabel: ''
  });

  protected showDialog = signal(false);

  preparePlaceholderText(type: string, aem?: BookWidgetAem | null) {
    let placeholder = aem?.airportsField.searchModal.originLabel;

    if (type === 'destination') {
      placeholder = aem?.airportsField.searchModal.destinationLabel;
    } else if (type === 'connection') {
      placeholder = aem?.airportsField.searchModal.connectionAirportLabel;
    }

    return placeholder || '';
  }
}
